import React from 'react';

export default function ConfirmModal({ open, title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', onConfirm, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 px-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-card border border-white/10 bg-slate-950 p-6 shadow-2xl shadow-black/40">
        <h3 className="text-lg font-black text-white">{title}</h3>
        <p className="mt-2 text-sm leading-6 text-slate-400">{message}</p>
        <div className="mt-5 flex justify-end gap-3">
          <button className="rounded-ctl border border-white/10 bg-white/5 px-4 py-2 text-sm font-bold text-slate-300 transition hover:text-white" onClick={() => { if (onClose) onClose(); }} aria-label="Cancel">{cancelLabel}</button>
          <button
            className="rounded-ctl bg-rose-500 px-4 py-2 text-sm font-bold text-white transition hover:bg-rose-400"
            onClick={() => { if (typeof onConfirm === 'function') onConfirm(); if (onClose) onClose(); }}
            aria-label="Confirm"
          >{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
